// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterCompact_footer__sqQIU","link":"FooterCompact_link__v5oi8"};